import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import {Controller, useForm} from "react-hook-form";
import {Alert, Button, CircularProgress, Stack, TextField} from "@mui/material";
import {Client, ClientFields, ClientType} from "../../../../../types/client/clientData";
import React, {ChangeEvent, Fragment, useContext, useState} from "react";
import {HttpClient} from "../../../../../http/client/httpClient";
import {Modules} from "../../../../../types/generalData";
import {EntityWithIdFields} from "../../../../../types/baseEntities";
import {HttpClientUser} from "../../../../../http/client/httpClientUser";
import Icon from "../../../../components/icon";
import ClientSummaryDialogCard from "./ClientSummaryDialogCard";
import toast from "react-hot-toast";
import ReplayIcon from "@mui/icons-material/Replay";
import useAxios from "../../../../../hooks/useAxios";
import {CompanyContext, CompanyContextValue} from "../../../../../pages/solicitation-new/context/companyContext";

interface CompanyCuitSyncDialogContentProps {
    subtitle: string,
    saveClient?: boolean,
    onSave?: (client: Client) => void,
    action?: () => void,
    inline?: boolean
}



const CompanyCuitSyncDialogContent = ({subtitle, saveClient, onSave, action, inline = false}: CompanyCuitSyncDialogContentProps) => {
    const [cuitValidated, setCuitValidated] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(false)
    const [error, setError] = useState<boolean>(false)
    const [cuit, setCuit] = useState<string>('')
    const [client, setClient] = useState<Client>()
    const [errorCompany, setErrorCompany] = useState<string>()
    const { control } = useForm()
    const {setClientId} = useContext<CompanyContextValue>(CompanyContext)
    
    const {fetchData} = useAxios()

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        setCuit(e.target.value)
    }
    const handleClick = () => {
        setLoading(true)
        setErrorCompany(undefined)
        HttpClient.sincronizeClientByCUIT(cuit, Modules.SolicitationOnboarding).then((r) => {
            if (r.tieneError) {
                setError(true)
                setLoading(false)
            } else {
                if (inline && r.data[ClientFields.ClientTypeCode] === ClientType.Juridica) {
                    setLoading(false)
                    toast.error('No puede cargar personas jurídicas como cónyuge.')
                }else {
                    setClient(r.data)
                    setCuitValidated(true)
                }
            }
        }).catch(() => {
            setError(true)
            setLoading(false)
        })
    }

    const onSaveClient = () => {
        if (client) {
            fetchData(
                () => HttpClientUser.insert(client[EntityWithIdFields.Id]),
                true
            )
                .then(() => {
                    toast.success("La empresa se guardó correctamente")
                    action && action()
                    setClientId(client[EntityWithIdFields.Id])
                }).catch(() => {
                    setErrorCompany('La empresa ya existe')
            })
        }
    }


    const handleBack = () => {
        setCuitValidated(false)
        setClient(undefined)
    }
    
    const handleSave = () => {
        client && onSave && onSave(client)
    }
    
    return (
        <Grid container justifyContent={'center'} spacing={4}>
            {
                (!cuitValidated || !client) ?
                    <Fragment>
                        {
                            !error &&
                            <Fragment>
                                <Grid item xs={12}>
                                    <Typography fontSize={16} textAlign={'center'}>{subtitle}</Typography>
                                </Grid>
                                <Grid item xs={inline ? 6 : 4} justifyContent={inline ? 'end' : 'center'} textAlign={inline ? 'end' : 'start'}>
                                    <Controller
                                        control={control}
                                        name='empresa-cuit'
                                        render={({ }) => (
                                            <TextField
                                                value={cuit}
                                                onChange={handleChange}
                                                size='small'
                                                label='CUIT/CUIL'
                                            />
                                        )}
                                    />
                                </Grid>
                                <Grid item xs={inline ? 6 : 12} textAlign={inline ? 'start' : 'center'}>
                                    <Button color='primary' variant='contained' onClick={handleClick}>Validar</Button>
                                </Grid>
                            </Fragment>
                        }
                        {
                            loading ?
                            <Stack alignItems={'center'} justifyContent={'center'} textAlign={'center'} pt={3} spacing={2}>
                                <CircularProgress color="primary" size={40} value={40} />
                                <Typography fontSize={14}>Aguarde mientras buscamos el CUIT/CUIL en la base de datos...</Typography>
                            </Stack>
                            : error &&
                                <Stack alignItems={'center'} spacing={3} textAlign={'center'}>
                                    <Alert severity={'error'} sx={{mt: 3}}>El CUIT ingresado es incorrecto. Reintente nuevamente.</Alert>
                                    <Button color="primary" size="small" variant="contained" endIcon={<ReplayIcon />} onClick={() => {setError(false)}}>
                                        Recargar
                                    </Button>
                                </Stack>
                        }
                    </Fragment>
                    :
                    <Fragment>
                        <Grid item xs={12} justifyContent={'center'} spacing={2}>
                            <Typography fontSize={18} textAlign={'center'}>{`Se encontró la siguiente ${client[ClientFields.ClientTypeCode] === ClientType.Fisica ? 'persona' : 'empresa'} relacionada al CUIT ingresado`}</Typography>
                        </Grid>
                        <Grid item xs={inline ? 8 : 12} mt={1} mb={1} justifyContent={'center'} textAlign={'center'}>
                            <ClientSummaryDialogCard client={client} action={() => {setLoading(false)}}/>
                        </Grid>
                        <Grid item xs={inline ? 8 : 12} container alignItems={'center'}>
                            <Grid item xs={6}>
                                <Button color={'secondary'} variant={'contained'} onClick={handleBack} startIcon={<Icon icon='mdi:chevron-left' fontSize={20} />}>Volver</Button>
                            </Grid>
                            <Grid item xs={6} textAlign={'end'}>
                                <Button color={"primary"} variant={"contained"} onClick={saveClient ? onSaveClient : handleSave} endIcon={<Icon icon='mdi:chevron-right' fontSize={20} />}>
                                    {saveClient || inline ? 'Guardar' : 'Continuar'}
                                </Button>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            {errorCompany && errorCompany !== '' &&
                                <Alert severity={'error'}>{errorCompany}</Alert>
                            }
                        </Grid>
                    </Fragment>
            }
        </Grid>
    )
}


export default CompanyCuitSyncDialogContent